export default __webpack_public_path__ + "static/about-fama-27736a9cb03abb7647a3a865e07b0f2f.jpg";